import { Helmet } from "react-helmet-async";

const BASE_URL = "https://wgr.mwsgkp.in";
const DEFAULT_IMAGE = `${BASE_URL}/seo-image.png`;

export default function SEO({
  title,
  description,
  image = DEFAULT_IMAGE,
  url = BASE_URL,
}) {
  return (
    <Helmet>
      <title>{title}</title>

      <meta name="description" content={description} />

      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      <meta name="robots" content="index,follow" />
       <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "GovernmentOrganization",
          name: "Mechanical Workshop, North Eastern Railway, Gorakhpur",
          url: "https://wgr.mwsgkp.in",
          logo: "https://wgr.mwsgkp.in/logo512.png",
        })}
      </script>
    </Helmet>
  );
}